import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ReviewCards } from '@/components/ReviewCards';
import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { AnimationFill } from '@/pages/Onboarding/components/AnimationFill';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { useBotInfoWithPreload } from '@/pages/Onboarding/Layouts/OwnAI_Trans/hooks/useTransBotInfo.ts';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { ScreenSettingUpProfileStyles } from './SettingUpProfile.styles';

const animationSteps = [
  {
    delay: 0,
    label: 'Processing your request',
  },
  {
    delay: 4,
    label: 'Initializing AI modules',
  },
  {
    delay: 8,
    label: 'Creating your AI trans girlfriend',
  },
];

export const ScreenSettingUpProfile: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SettingUpProfile',
      });
    }
  }, []);

  useBotInfoWithPreload('summary');

  const { wizard } = useOnboarding();
  const [disabledNextStep, setDisabledNextStep] = React.useState<boolean>(true);

  const handleNextStep = () => {
    nextStepTimeout(wizard.nextStep);
  };

  const onFinishAnimation = () => {
    setDisabledNextStep(false);
  };

  return (
    <ScreenSettingUpProfileStyles>
      <OwnAiTitle className="setting-up-title">
        Setting up your profile...
      </OwnAiTitle>
      <OnboardingSubtitle className="setting-up-subtitle">
        It will take less than one minute
      </OnboardingSubtitle>

      <IonContent>
        <AnimationFill
          onComplete={onFinishAnimation}
          show
          steps={animationSteps}
          stepDuration={4}
          progressStyles={{
            backgroundColor: '#262130',
          }}
        />

        <section className="setting-up-user-reviews">
          <UiTypography variant="title-medium" align="center" transform="bold">
            Trusted by 1,556,867 users
          </UiTypography>
          <ReviewCards />
        </section>
      </IonContent>

      <OnboardingFooter
        disabled={disabledNextStep}
        onContinue={handleNextStep}
      />
    </ScreenSettingUpProfileStyles>
  );
};
